import React from 'react'
import { useEffect } from 'react';
import { useState, useRef } from 'react';
import { dataLimit, theme } from '../../../..';
import {
    deleteDocument, fetch_courses_documents,
    getDocumentPlaylist, createDocumentPlaylist, deleteDocuentPlayList, getCourseCancellationRequest
} from '../../../../api/Courses';
import { fetch_document_playlist, addDocument, editDocumentDetails, editDocumentFile } from '../../../../api/document';
import CourseCancellationRequestRow from './CourseCancellationRequestRow';
import { Image, Shimmer } from 'react-shimmer'
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../../components/modal/modal';
import ClipLoader from "react-spinners/ClipLoader";
import { max } from 'moment';
import Snackbar from '@material-ui/core/Snackbar';
import { s3Delete, s3upload } from '../../../../api/aws';
import { useSelector } from 'react-redux';
export const COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS = {
    Pending: "PENDING",
    Cancelled: "CANCELLED",
    DONE_BY_DUBUDDY: "DONE_BY_DUBUDDY"
}

function CourseCancellationRequest(props) {
    const insDetails = useSelector((state) => state.ins.insDetails)
    const { activeCourse, courseName, setDocCount, docCount, setAllowRedirect, setProcessingInParent, setProgressInParent } = props
    const [courseCancellationRequests, setCourseCancellationRequests] = useState([])
    const [courseDocumentLoaded, setCourseCancellationRequestLoaded] = useState(false);
    const [isCourseCancellationRequestLoading, setIsCourseCancellationRequestLoading] = useState(true);
    const [offset, setOffset] = useState(0)
    const [showShimmer, setShowShimmer] = useState(true)
    const [allDataLoaded, setAllDataLoaded] = useState(false)
    const [showNextButton, setShowNextButton] = useState()
    const [selectedStatusOptionName, setSelectedStatusOptionName] = useState(COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS.Pending)
    const [SnackBarMessage, setSnackBarMessage] = useState()
    const [isSnackBarShow, setIsSnackBarShow] = useState(false)

    const [delLoading, setDelLoading] = useState(false);

    const [status, setStatus] = useState(COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS.Pending)
    useEffect(() => {

        getCourseCancellationRequest(activeCourse, status, offset, dataLimit, courseDocumentCallback);
    }, [activeCourse, offset])

    const courseDocumentCallback = (response) => {
        console.log(response.status)
        if (response.status == 200) {
            response.json().then(data => {
                if (data.content.length == dataLimit) {
                    setCourseCancellationRequests(data.content)
                    setShowNextButton(true)
                }
                else if (data.content.length < dataLimit) {
                    if (data.content.length == 0) {
                        if (offset == 0) {
                            setOffset(0)
                        } else {
                            setOffset(offset - 1)
                        }
                    }
                    else if (data.content.length != 0) {
                        setCourseCancellationRequests(data.content)
                    }
                    setShowNextButton(false)
                    setAllDataLoaded(true)
                }
                setCourseCancellationRequestLoaded(true)
                setIsCourseCancellationRequestLoading(false)
                setShowShimmer(false)
            })
        }
    }

    const nextPageHandler = () => {
        if (!allDataLoaded) {
            setOffset(offset + 1)
        } else {
            window.alert("No more data available")

        }

    }

    const prePageHandler = () => {
        if (offset > 0) {
            setOffset(offset - 1)
        }
        else if (offset == 0) {
            setOffset(0)
            setShowNextButton(true)
        }
        setAllDataLoaded(false)
    }

    const deleteRowInterface = (index) => {
        const arr = [...courseCancellationRequests]
        arr.splice(index, 1)
        setCourseCancellationRequests(arr)
    }



    const closeSnack = () => {
        setIsSnackBarShow(false)
    }

    return (
        <div>
            <div class="page-breadcrumb  d-md-flex align-items-center mb-3">
                <div class="btn-group">
                    <button type="button" class="btn btn-primary">{selectedStatusOptionName}</button>
                    <button type="button" class="btn btn-primary bg-split-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown">	<span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg-left">
                        {Object.entries(COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS).map((row) => (
                            <a class="dropdown-item" href="javascript:;" onClick={() => {
                                if(offset==0)
                                {
                                    getCourseCancellationRequest(activeCourse, row[1], offset, dataLimit, courseDocumentCallback);
                                }else{
                                    setOffset(0)
                                }
                                setAllDataLoaded(false);
                                setStatus(row[1]); 
                                setSelectedStatusOptionName(row[0]);
                                setCourseCancellationRequests([]);
                                setShowShimmer(true)
                            }}>{row[0]}</a>
                        ))}
                    </div>
                </div>
                <div class="ml-auto">
                    <br />
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered mb-0" id="table1">
                            <thead class="thead-dark">
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Refund Amount</th>
                                    <th>Refund Reason</th>
                                    <th>Status</th>
                                    <th align="center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>

                                {showShimmer ? (
                                    <td colspan="6">
                                        <Shimmer width={'100%'} height={40} />
                                    </td>
                                ) : (
                                    <>
                                        {courseCancellationRequests.map((row, i) => (
                                            <CourseCancellationRequestRow
                                                row={row}
                                                index={i}
                                                deleteRowInterface={deleteRowInterface}
                                            />
                                        ))}
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Snackbar
                open={isSnackBarShow}
                onClose={(e) => closeSnack(e)}
                TransitionComponent="TransitionUp"
                message={SnackBarMessage}
            />
        </div>
    )
}

export default CourseCancellationRequest
